import {
  parseDate
} from "./chunk-C3UEOT3Y.mjs";

// src/date/day.ts
var startOfDay = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  d.setHours(0, 0, 0, 0);
  return d;
};
var endOfDay = (date) => {
  const d = typeof date === "string" ? parseDate(date) : date;
  d.setHours(23, 59, 59, 999);
  return d;
};

export {
  startOfDay,
  endOfDay
};
//# sourceMappingURL=chunk-JPPB7RRM.mjs.map